import React, { useEffect, useState } from 'react';
import styles from './Calendar.module.scss';
import { isEmpty } from 'lodash';
import moment from 'moment';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import DeletePopup from '../Custom/DeletePopup';
import { useDeleteCalendar } from '../../../Hooks/Calendar';
import { useToast } from '../Custom/CustomToaster/Toast';
import MoreButton from '../Custom/MoreButton';
import PopOver from '../Custom/PopOver/PopOver';
import Loader from '../Loader/Loader';
import NoDataComponent from '../Custom/NoDataComponent/NoDataComponent';
import Buttons from '../../Atoms/Buttons/Buttons';
import plus from '../../../assets/Imagess/plusvector.svg';

function CalendarTable({
  data,
  setIsModalOpen,
  setModalMode,
  setItem,
  refetchCalendar,
  itemToEdit,
  isLoading,
  handleNewClick,
}) {
  const customizedToast = useToast();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const {
    mutate: deleteCalendar,
    isLoading: isDeletingCalendar,
    isSuccess,
  } = useDeleteCalendar(itemToEdit?.calendarId);

  useEffect(() => {
    if (isSuccess) {
      refetchCalendar();
      setShowDeleteModal(false);
      customizedToast.open('تم حذف الحدث بنجاح');
      setItem({});
    }
  }, [isSuccess]);

  return (
    <div className={styles['calendar-table-container']}>
      {showDeleteModal && (
        <DeletePopup
          handleOnClose={() => setShowDeleteModal(false)}
          title={'الحدث'}
          handleDelete={() => {
            deleteCalendar();
          }}
          isLoading={isDeletingCalendar}
        />
      )}{' '}
      <div>
        <div className={styles.header}>
          <Buttons
            text='حدث جديد'
            icon={plus}
            rounded={true}
            color='rgba(13, 160, 110, 1)'
            handleOnClick={handleNewClick}
            style={{
              fontFamily: 'BukraMedium',
            }}
          />{' '}
          <div>
            <p className={styles['title']}>جميع الفعاليات</p>
            <p className={styles['sub-title']}>{data?.length} فعاليات</p>
          </div>
        </div>

        {!isEmpty(data) ? (
          <table className={styles['calendar-table']}>
            <thead className={styles['calendar-table-header']}>
              <tr>
                <th>التاريخ</th>
                <th>الاسم</th>
                <th></th>
              </tr>
            </thead>
            {isLoading ? (
              <Loader />
            ) : (
              <tbody className={styles['calendar-table-body']}>
                {data.map((item) => {
                  const fromDate = moment(item.fromDate);
                  const endDate = moment(item.endDate);
                  const displayDate = fromDate.isSame(endDate, 'day')
                    ? fromDate.format('MMMM D, YYYY')
                    : `${fromDate.format('MMMM D, YYYY')} - ${endDate.format(
                        'MMMM D, YYYY'
                      )}`;
                  return (
                    <tr key={item?.calendarId}>
                      <td>{displayDate}</td>
                      <td>
                        <div className={styles['text-container']}>
                          <div
                            className={styles['item-circle']}
                            style={{ backgroundColor: item?.colorCode }}
                          ></div>
                          {item?.calendarText}
                        </div>
                      </td>
                      <td>
                        <MoreButton icon={moreInfo} left='0'>
                          <PopOver
                            info={[
                              {
                                title: 'تعديل',
                                icon: editSvg,
                                handleFunction: () => {
                                  setIsModalOpen(true);
                                  setModalMode('edit');
                                  setItem(item);
                                },
                              },
                              {
                                title: 'حذف',
                                icon: deleteSvg,
                                handleFunction: () => {
                                  setShowDeleteModal(true);
                                  setItem(item);
                                },
                              },
                            ]}
                          />
                        </MoreButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <NoDataComponent />
          </div>
        )}
      </div>
    </div>
  );
}

export default CalendarTable;
